import { SiriusBaseComponent } from 'sirius-framework';
import { Router, ActivatedRoute, Params, NavigationEnd } from '@angular/router'
import { ViewChild,OnDestroy, ElementRef, Component, Renderer2 } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Images } from '../../models/images.model'; 
import { MenuItem,MenuItemType } from '../../models/menuItem';
import { Subscription } from 'rxjs'; 
import { CommonService } from '../../service/shared.service';
import { SiteLanguageService } from '../../service/site-language.service';

 const HEADER_KEYS = {
    brandLine1: 'yediEminHeaderBrandLine1',
    brandLine2: 'yediEminHeaderBrandLine2',
    loginButton: 'yediEminHeaderLoginButton',
    signOutButton: 'yediEminHeaderSignOutButton',
    menuHelp: 'yediEminHeaderMenuHelp',
    menuHome: 'yediEminHeaderMenuHome',
    langEnglish: 'yediEminHeaderLangEnglish',
    langTurkish: 'yediEminHeaderLangTurkish',
    ariaToggleNav: 'yediEminHeaderAriaToggleNavigation',
};

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'] 
})

export class HeaderComponent extends SiriusBaseComponent<any> implements OnDestroy {   
    @ViewChild('navbarToggler') navbarToggler: ElementRef;
    @ViewChild('navbarCollapse') navbarCollapse: ElementRef;  
    _images = Images;
    subscriptionLoggedId: Subscription;
    subscriptionLoggedUser: Subscription;
    subscriptionLoginPageControl: Subscription;
    private langSub: Subscription;
    private headerLanguageLinkSub: Subscription;
    /** Dil linki: login’de ilk submit sonrası false; landing’de true (CommonService). */
    showHeaderLanguageLink = true;
    notLoginPage: boolean = true;
    isLoggedIn: boolean = false;
    loggedUserName: string;
    isHeightLong: boolean = true;
    isCollapsed: boolean = true;
    loginButtonText = 'Giriş';
    signOutButtonText = 'Çıkış';
    brandLine1 = 'Güvenli';
    brandLine2 = 'Ödeme Sistemi';
    menuTextHelp = 'Yardım';
    menuTextHome = 'Ana Sayfa';
    langEnglish = 'English';
    langTurkish = 'Türkçe';
    ariaToggleNav = 'Menüyü aç/kapat';
    menuItems: MenuItem[] = [];
    /**
     * Menü öğeleri closure'da değil, bileşen alanında tutulur. Böylece dil değişince
     * dizide olmasalar bile (ör. login öncesi menuItem2) metinleri güncellenebilir
     * ve sonradan push edildiklerinde doğru dilde görünürler.
     */
    private menuItemHelp: MenuItem;
    private menuItemHome: MenuItem;
    constructor(private router: Router, private renderer: Renderer2, private domSanitizer: DomSanitizer, private commonService: CommonService, public siteLanguage: SiteLanguageService) {
        super();     
        this.commonService.notAtLoginPage.next(true);
    }
    OnInit() {
        this.langSub = this.siteLanguage.languageCode$.subscribe(() => {
            this.loadHeaderResourceStrings();
            this.syncMenuItemLabels();
        });
        this.router.events.subscribe(e => {
          if (e instanceof NavigationEnd) {
                // route değişirse menüyü kapat ve scroll'u aç
                 this.renderer.removeClass(document.body, 'block-scroll');
                 this.renderer.removeClass(this.navbarCollapse.nativeElement, "show");
                 
                if (e.urlAfterRedirects.includes('/landing')) {
                    this.isHeightLong = true;
                }
                else {
                    this.isHeightLong = false;
                }
            }
        });
        this.renderer.listen('window', 'click', (e: Event) => {
          if (this.navbarCollapse.nativeElement.classList.contains('show') &&
            e.target !== this.navbarCollapse.nativeElement &&
            e.target !== this.navbarToggler.nativeElement) {
            this.isCollapsed = true;
            this.renderer.removeClass(this.navbarCollapse.nativeElement, "show");
          } else if (!this.isCollapsed) { 
            this.renderer.addClass(this.navbarCollapse.nativeElement, "show");
          }
        });
        this.menuItemHelp = new MenuItem();
        this.menuItemHelp.text = this.menuTextHelp;
        this.menuItemHelp.itemCssClass = 'nav-item';
        this.menuItemHelp.linkCssClass = 'nav-link';
        this.menuItemHelp.routeLink = '/faq';
        this.menuItemHelp.type = MenuItemType.Text;
        this.menuItems.push(this.menuItemHelp);
        this.menuItemHome = new MenuItem();
        this.menuItemHome.text = this.menuTextHome;
        this.menuItemHome.itemCssClass = 'nav-item';
        this.menuItemHome.linkCssClass = 'nav-link';
        this.menuItemHome.routeLink = '/inner-menu';
        this.menuItemHome.type = MenuItemType.Text;
        

        this.subscriptionLoggedId = this.commonService.isLoggedin.subscribe(state => {
            this.isLoggedIn = (state == true);
            if (this.isLoggedIn) {
                this.menuItems.push(this.menuItemHome);
            }
            else {
                this.menuItems = [];
                this.menuItems.push(this.menuItemHelp);
            }
        });
        this.subscriptionLoggedUser = this.commonService.loggedUserName.subscribe(state => {
            this.loggedUserName =  state;
        });
        this.subscriptionLoginPageControl = this.commonService.notAtLoginPage.subscribe(state => {
            if (state == false)
                this.notLoginPage = false;
            else
                this.notLoginPage = true;
        });
        this.headerLanguageLinkSub = this.commonService.headerLanguageLinkVisible.subscribe((visible) => {
            this.showHeaderLanguageLink = visible;
        });
    }

    /**
     * Dil değişince menü öğesi metinlerini güncelle. Item'lar menuItems dizisinde
     * olmasa bile (ör. kullanıcı login olmadan önce menuItemHome henüz pushlanmadı)
     * referans üzerinden güncellendikleri için login sonrası doğru dilde görünürler.
     */
    private syncMenuItemLabels(): void {
        if (this.menuItemHelp) {
            this.menuItemHelp.text = this.menuTextHelp;
        }
        if (this.menuItemHome) {
            this.menuItemHome.text = this.menuTextHome;
        }
    }

    private loadHeaderResourceStrings(): void {
        this.brandLine1 = this.commonService.getStringResource(HEADER_KEYS.brandLine1, this.brandLine1);
        this.brandLine2 = this.commonService.getStringResource(HEADER_KEYS.brandLine2, this.brandLine2);
        this.loginButtonText = this.commonService.getStringResource(HEADER_KEYS.loginButton, this.loginButtonText);
        this.signOutButtonText = this.commonService.getStringResource(HEADER_KEYS.signOutButton, this.signOutButtonText);
        this.menuTextHelp = this.commonService.getStringResource(HEADER_KEYS.menuHelp, this.menuTextHelp);
        this.menuTextHome = this.commonService.getStringResource(HEADER_KEYS.menuHome, this.menuTextHome);
        this.langEnglish = this.commonService.getStringResource(HEADER_KEYS.langEnglish, this.langEnglish);
        this.langTurkish = this.commonService.getStringResource(HEADER_KEYS.langTurkish, this.langTurkish);
        this.ariaToggleNav = this.commonService.getStringResource(HEADER_KEYS.ariaToggleNav, this.ariaToggleNav);
    }

    onLanguageToggle(event: Event): void {
        event.preventDefault();
        this.siteLanguage.toggleLanguage();
    }

    onLanguageToggleMobile(event: Event): void {
        this.onLanguageToggle(event);
        this.closeMenuOnNavigate();
    }
    ngOnDestroy() {
        if (this.langSub) {
            this.langSub.unsubscribe();
        }
        this.subscriptionLoggedId.unsubscribe();
        this.subscriptionLoggedUser.unsubscribe();
        this.subscriptionLoginPageControl.unsubscribe();
        if (this.headerLanguageLinkSub) {
            this.headerLanguageLinkSub.unsubscribe();
        }
        this.renderer.removeClass(document.body, 'block-scroll');
    }
    getHeaderImage() {
        return this.domSanitizer.bypassSecurityTrustStyle(`url(${Images.Other.Logo})`);                      
    }
    getHeaderImageShort() {
        return this.domSanitizer.bypassSecurityTrustStyle(`url(${Images.Other.LogoScroll})`); 
    }
    goLogin() {
      this.startTransaction('LoginFormTransaction');
    }
    onMenuClick() {
        this.isCollapsed = !this.isCollapsed;
        this.arrangeBody();
    }
    arrangeBody() {
        if (!this.isCollapsed) {
            this.renderer.addClass(document.body, 'block-scroll');
        } else {
            this.renderer.removeClass(document.body, 'block-scroll');
        }
  }

  closeMenuOnNavigate() {
    if (!this.isCollapsed) {
      this.isCollapsed = true;
      this.arrangeBody();
      this.renderer.removeClass(this.navbarCollapse.nativeElement, "show");
    }
  }

    signOut() { 
        this.commonService.logOut(false);
    }
}
